import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const fetchHealth = (childId, password) => {
    return RESTClient.postAuthenticatedObservable(`v2/children/${childId}/health/auth`, {
        password,
    }).map(({updateToken, ...health}) => ({updateToken, health}));
};

export const updateHealth = (childId, data, updateToken = {}) => {
    return RESTClient.postAuthenticatedObservable(`v2/children/${childId}/health`, {
        ...data,
        ...updateToken,
    });
};
